// extracted by mini-css-extract-plugin
module.exports = {"solar-calculator":"NewVersion_solar-calculator__q2MGH"};